<template
  ><div class="password-form">
    <div v-if="!isPasswordSet">
      <VForm
        :name="name"
        :initialValues="initialValues"
        :fields="fields"
      ></VForm>
    </div>
    <div class="password-set" v-else>
      <div class="title">Your have set your password already</div>
      <div class="description">
        You can change it in the account settings <br />
        when registration completed
      </div>
    </div>
    <div class="btn-wrapper">
      <VButton
        label="Continue"
        :disabled="(!_isFormValid || isLoading) && !isPasswordSet"
        @click="onBtnClick()"
      ></VButton>
    </div></div
></template>

<script>
import Vue from "vue";

import { mapActions, mapGetters } from "vuex";
import { required, minLength } from "@/utils/validations";

//components
import VForm from "@/components/VForm";
import VButton from "@/components/VButton";

//mixins
import withFormUtils from "@/mixins/withFormUtils";
import withToasted from "@/mixins/withToasted";
import withDialogWindowsSequence from "@/mixins/withDialogWindowsSequence";
import withValidation from "@/mixins/withValidation";

export default Vue.component("SignUpPasswordForm", {
  components: { VForm, VButton },

  data() {
    return {
      name: "signUpPassword",
      initialValues: {},
      fields: [
        {
          name: "password",
          type: "password",
          label: "Password",
          placeholder: "Create a password...",
          validate: [required, minLength(8), this.checkPasswords]
        },
        {
          name: "password_repeat",
          type: "password",
          label: "Confirm Password",
          placeholder: "Confirm your password",
          validate: [required, minLength(8), this.checkPasswords]
        }
      ]
    };
  },

  mixins: [
    withFormUtils,
    withToasted,
    withDialogWindowsSequence,
    withValidation
  ],

  computed: {
    _isFormValid() {
      return this.isFormValid(this.name);
    },

    isPasswordSet() {
      return Boolean(localStorage.getItem("passwordSet"));
    },

    ...mapGetters("account", ["isLoading"])
  },

  methods: {
    onBtnClick() {
      if (this.isPasswordSet) {
        this.nextSequencePage();
        return;
      }

      this.validateForm(this.name);
      if (JSON.parse(localStorage.getItem(this.name))) {
        this.nextSequencePage();
      } else if (this._isFormValid) {
        return this.updateUser({
          patch: true,
          values: {
            password: this.formValues.password,
            password_repeat: this.formValues.password_repeat
          },
          onSuccess: () => {
            localStorage.setItem("passwordSet", "true");
            this.nextSequencePage();
          },
          onError: () =>
            this.errorToast("Form is valid but account cant be updated")
        });
      }
    },

    ...mapActions("account", ["updateUser"])
  },

  created() {
    if (JSON.parse(localStorage.getItem(this.name))) {
      this.initialValues = JSON.parse(localStorage.getItem(this.name));
    }
  }
});
</script>

<style lang="scss" scoped>
.password-form {
  height: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
}

.password-set {
  text-align: center;
  line-height: 1.5;
  padding-top: 40px;

  .title {
    margin-bottom: 25px;
    font-size: 18px;
    color: $primary-color;
  }
}
</style>
